export default "__VITE_ASSET__CB$aHcwU__"